<template>
    <!-- <idc-table :tabsData="tabsData" :active="'message'" class="bg-default border"></idc-table> -->
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="label1" :badgeLength="badgeLength" name="first">
                <message ref="test" @clear-first="firstClear" @clear-second="secondClear" :status="activeName" :notice="notice" :doThing="doThing" />
            </el-tab-pane>
            <el-tab-pane :label="label2" name="second">
                <message ref="test" @clear-first="firstClear" @clear-second="secondClear" :status="activeName" :notice="notice" :doThing="doThing" :badgeLength="badgeLength" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import message from './tabs/message';
import commission from './tabs/commission';
export default {
    components: {
        message
    },
    props: {
        notice: {
            type: null,
            default: () => {
                return [];
            }
        },
        doThing: {
            type: null,
            default: () => {
                return [];
            }
        },
        badgeLength: {
            type: null,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            activeName: 'first',
            label1: '',
            label2: ''
        };
    },
    computed: {
        tabsData() {
            return [
                // { src: 'message', name: ' 系统消息', isNew: true, component: message },
                // { src: 'commission', name: '代办', isNew: false, component: commission }
            ];
        }
    },
    created() {},
    mounted() {
        this.label1 = `系统通知(${this.notice.length})`;
        this.label2 = `待办(${this.doThing.length})`;
    },
    methods: {
        handleClick(tab, event) {
            this.activeName = tab.$vnode.name || tab.$vnode.componentOptions.propsData.name;
        },
        test222() {},
        firstClear() {
            //  this.label1 += `(${0})`
            this.$emit('son-clear1');
        },
        secondClear() {
            //    this.label2 += `(${0})`
            this.$emit('son-clear2');
        }
    }
};
</script>
